export default __webpack_public_path__ + "static/media/capybara.7150bdf9.gif";